// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__KuCiL","footer":"ChangeClinic_footer__2TcFX"};